<sz-bottom-sheet [open]="open()" (close)="onDismiss()">
  <div szSheetHeader class="rating__head">
    <h3 class="rating__title">{{ 'rating.title' | translate }}</h3>
    <p class="rating__subtitle">{{ 'rating.subtitle' | translate }}</p>
  </div>

  <div class="rating__stars" role="radiogroup" [attr.aria-label]="'rating.title' | translate">
    @for (s of stars; track s) {
      <button
        type="button"
        class="rating__star"
        [class.is-active]="s <= selected()"
        [attr.aria-label]="s + '/5'"
        [attr.aria-pressed]="s <= selected()"
        (click)="select(s)">
        {{ s <= selected() ? '★' : '☆' }}
      </button>
    }
  </div>

  @if (showComment()) {
    <label class="rating__comment-label" for="rating-comment">
      {{ 'rating.commentLabel' | translate }}
    </label>
    <textarea
      id="rating-comment"
      class="rating__comment"
      rows="4"
      maxlength="1000"
      [value]="comment()"
      (input)="onCommentInput($event)"
      [attr.placeholder]="'rating.commentPlaceholder' | translate"></textarea>
  }

  <div szSheetCta class="rating__cta">
    <sz-button variant="primary" [fullWidth]="true" [disabled]="selected() < 1 || submitting()" (click)="onSubmit()">
      {{ 'rating.submit' | translate }}
    </sz-button>
    <sz-button variant="ghost" [fullWidth]="true" (click)="onDismiss()">
      {{ 'rating.later' | translate }}
    </sz-button>
  </div>
</sz-bottom-sheet>
